import toast from 'react-hot-toast';
import i18n from 'src/i18n';

export type EdrPreviewActionMessageKey = 'previewMutationBlocked' | 'previewExportBlocked';

/** Returns true when the action was blocked (preview mode). */
export const guardEdrPreviewAction = (
  isPreviewMode: boolean,
  messageKey: EdrPreviewActionMessageKey = 'previewMutationBlocked',
): boolean => {
  if (!isPreviewMode) return false;
  toast.error(i18n.t(messageKey, { ns: 'securityEdr' }));
  return true;
};
